export function stripCpfDigits(value: string): string {
  return value.replace(/\D/g, '').slice(0, 11);
}

export function formatCpfDisplay(digits: string): string {
  const value = stripCpfDigits(digits);

  if (value.length <= 3) {
    return value;
  }

  if (value.length <= 6) {
    return `${value.slice(0, 3)}.${value.slice(3)}`;
  }

  if (value.length <= 9) {
    return `${value.slice(0, 3)}.${value.slice(3, 6)}.${value.slice(6)}`;
  }

  return `${value.slice(0, 3)}.${value.slice(3, 6)}.${value.slice(6, 9)}-${value.slice(9)}`;
}
